import { FC } from 'react';
import { Button } from '../../components/button/button';
import { Modal } from '../../components/modal/modal';
import { useLang } from '../../hooks/use-lang';
import { useQueryParams } from '../../hooks/use-query-params';
import { useToggle } from '../../hooks/use-toggle';
import s from './delete-modal.module.css';

interface Props {
  onSubmit: (id: string) => Promise<void>;
  prefix?: string;
}

/**
 *Для корректной работы в addQueryParams необходимо передавать
 * @type {Record<string, string>} params
 * @property {string} deleteId - id удаляемого элемента
 * @property {string} deleteName - наименование удаляемого элемента
 * @property {string} prefix - префикс для уникальности id
 */

export const DeleteModal: FC<Props> = (props) => {
  const { onSubmit, prefix } = props;
  const { t } = useLang();

  const { addQueryParams, getQueryParams } = useQueryParams();
  const params = getQueryParams();

  const deleteId = params.deleteId;
  const deleteName = params.deleteName;
  const deletePrefix = params.deletePrefix;

  const [isLoading, , setIsLoading] = useToggle();

  const handleClose = () => {
    addQueryParams({
      deleteId: undefined,
      deleteName: undefined,
      deletePrefix: undefined,
    });
  };

  const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      setIsLoading(true);
      await onSubmit(deleteId);
      handleClose();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const isSamePrefix = deletePrefix === prefix;

  const isSamePrefixAndId = isSamePrefix && !!deleteId;

  const isOpen = prefix ? isSamePrefixAndId : !!deleteId;

  if (!isOpen) return null;

  return (
    <Modal className={s.feature} title={t('Удаление')} onClose={handleClose}>
      {t('Вы действительно хотите удалить {{name}}?', {
        name: deleteName,
      })}

      <div className={s.controls}>
        <Button onClick={handleClose} disabled={isLoading} variant="secondary">
          {t('Отменить')}
        </Button>
        <Button onClick={handleSubmit} disabled={isLoading}>
          {t('Удалить')}
        </Button>
      </div>
    </Modal>
  );
};
